export default {
      id: "icon-backtotop-usage",
      viewBox: "0 0 16 23",
      url: __webpack_public_path__ + "icons.svg#icon-backtotop",
      toString: function () {
        return this.url;
      }
    }